import React from "react";
import classes from "./index.module.css";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const TermConditions = () => {
  return (
    <div style={{ marginTop: "20px" }}>
      <Paper style={{ padding: "30px" }}>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          1. Introduction to Privacy Policy
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The terms and conditions contained hereinafter ("TERMS OF USE") shall
          apply to the use of the website www.teamplayer.in and any other linked
          pages, products, software(s), API keys, features, content or
          application services (including but without limitation to any mobile
          application services) in connection therewith, offered from time to
          time by Igloo Digital Technologies Private Limited ("IGLOO DIGITAL
          TECHNOLOGIES PVT LTD" or "WE" or "OUR" or "US" or “TEAM PLAYER”)
          (collectively, "WEBSITE").
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Any person logging on to or using the Website (even when such person
          does not avail of any services provided in the Website ("SERVICES"))
          (hereinafter referred to as a "USER", "SELLER", "YOU" or "CLIENT")
          shall be presumed to have read these Terms of Use (which includes the
          Privacy Policy, separately put up on the Website) and unconditionally
          and irrevocably accepted the terms and conditions set out herein
          (these Terms of Use). These Terms of Use, together with the rest of
          the Policies (defined below), constitute a binding and enforceable
          agreement between the User and Igloo Digital Technologies Pvt Ltd.
          These Terms of Use do not alter in any way the terms or conditions of
          any other written agreement you may have with Igloo Digital
          Technologies Pvt Ltd for other services.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Please read the terms set out hereunder carefully before agreeing to
          the same. If you do not agree to these Terms of Use (including any
          referenced policies or guidelines), please immediately terminate your
          use of the Website. You can accept the Terms of Use by:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. Clicking to accept or agree to the Terms of Use, where this option
          is made available to you by Igloo Digital Technologies Pvt Ltd in the
          User interface for any particular Service; or
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. Accessing, testing or actually using the Services. In this case,
          you understand and agree that Igloo Digital Technologies Pvt Ltd will
          treat your use of the Services as acceptance of the Terms of Use from
          that point onwards.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          It is clarified that the Privacy Policy (that is provided separately),
          form an integral part of these Terms of Use and should be read
          contemporaneously with the Terms of Use. Illegality or
          unenforceability of one or more provisions of these Terms of Use shall
          not affect the legality and enforceability of the other terms of the
          Terms of Use. For avoidance of doubt, if any of the provisions becomes
          void or unenforceable, the rest of the provisions of these Terms of
          Use shall be binding upon the User.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The Terms of Use may be revised or altered by us at our sole
          discretion at any time without any prior intimation to the User. The
          latest Terms of Use will be posted here. Any such changes by Igloo
          Digital Technologies Pvt Ltd will be effective immediately. By
          continuing to use this Website or to access the Services / usage of
          our Services after changes are made, you agree to be bound by the
          revised/ amended Terms of Use and such amendments shall supersede all
          other terms of use previously accepted by the User. You are solely
          responsible for understanding and complying with all applicable laws
          of your specific jurisdiction that may be applicable to you in
          connection with your business and use of our Services.{" "}
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          2. Provision of the Services being offered by Igloo Digital
          Technologies Pvt Ltd
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Subject to these Terms of Use, Privacy Policy, Service Provider
          Agreement (collectively, "POLICIES"), Igloo Digital Technologies Pvt
          Ltd offers the Services set forth in Schedule I herein.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Igloo Digital Technologies Pvt Ltd is constantly evolving in order to
          provide the best possible experience and information to its Users. You
          acknowledge and agree that the form and nature of the Services which
          Igloo Digital Technologies Pvt Ltd provides may change from time to
          time without any prior notice to you.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          As part of this continuing process, you acknowledge and agree that
          Igloo Digital Technologies Pvt Ltd may stop (permanently or
          temporarily) providing the Services (or any features within the
          Services) to you or to Users generally at Igloo Digital Technologies
          Pvt Ltd's sole discretion, without any prior notice. You may stop
          using the Services at any point of time. You need to specifically
          inform Igloo Digital Technologies Pvt Ltd when you stop using the
          Services. You acknowledge and agree that if Igloo Digital Technologies
          Pvt Ltd disables access to your account, you may be prevented from
          accessing the Services, your account details or any files or other
          content which is contained in your account, and Igloo Digital
          Technologies Pvt Ltd shall intimate you regarding the same.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Igloo Digital Technologies Pvt Ltd reserves the right to delete your
          User information stored in your account including but not limited to
          all or any personal information or any sensitive personal data or
          information ("SPDI") stored in your User account. Alternately, a User
          may notify us if they do not wish that we retain or use the personal
          information or SPDI by contacting the Grievance Officer (as provided
          below). However, in such a case, we may not be able to provide you
          some or all of our Services.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You acknowledge and agree that while Igloo Digital Technologies Pvt
          Ltd may not currently have set a fixed upper limit on the number of
          transmissions you may send or receive through the Services, such fixed
          upper limits may be set by Igloo Digital Technologies Pvt Ltd at any
          time, solely at Igloo Digital Technologies Pvt Ltd's discretion.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          By using our Services you agree that Igloo Digital Technologies Pvt
          Ltd disclaims any liability or authenticity of any information that
          may have become outdated since the last time that particular piece of
          information was updated. Igloo Digital Technologies Pvt Ltd reserves
          the right to make changes and corrections to any part of the content
          of this Website at any time without any prior notice to you. Unless
          stated otherwise, all pictures and information contained on this
          Website are believed to be in the public domain as either promotional
          materials, publicity photos, photoshoot rejects or press media stock.
          Please contact the Grievance Officer by an e-mail if you are the
          copyright owner of any content on this Website and you think the use
          of the above material violates the terms of the applicable Copyright
          law in any manner. In your request, please indicate the exact URL of
          the webpage to enable us to locate the same. We will endeavour to
          address your concerns and take necessary steps, if required. Please
          note that all images displayed on the Website have been digitised by
          Igloo Digital Technologies Pvt Ltd. No other party is authorised to
          reproduce or republish these digital versions in any format whatsoever
          without the prior written permission of Igloo Digital Technologies Pvt
          Ltd.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          3. Use of the Services by User
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          In order to access certain Services, you may be required to open a
          User account with Igloo Digital Technologies Pvt Ltd by providing
          information about yourself (such as identification or contact details)
          as part of the registration/sign up process ("REGISTRATION DATA") for
          the Services, or as part of your continued use of the Services. You
          agree that any Registration Data you give to Igloo Digital
          Technologies Pvt Ltd will always be accurate, correct, complete and up
          to date. If you provide any information that is untrue, inaccurate,
          incomplete, or not current or if we have reasonable grounds to suspect
          that such information is in violation of applicable law or not in
          accordance with the Terms of Use (whether wholly or in part), we
          reserve the right to reject your registration and/ or indefinitely
          suspend or terminate your User account and refuse to provide you
          access to the Website. Further, you agree to indemnify and keep us
          indemnified from and against all claims resulting from the use of any
          detail/ information/ Registration Data that you post and/ or supply to
          us. We shall be entitled to remove any such detail/ information/
          Registration Data posted by you without any prior intimation to you.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Notwithstanding anything else contained in any other agreement
          involving you and Igloo Digital Technologies Pvt Ltd and/ or any other
          third party, in order to ensure that we are not violating any right
          that you might have in your Registration Data, you hereby grant to us
          a non-exclusive, worldwide, perpetual, irrevocable, royalty-free,
          sub-licensable right to exercise the copyright, publicity, and
          database rights (but no other rights) that you have in the
          Registration Data, in any media now or in future known, with respect
          to your Registration Data solely to enable us to use such Registration
          Data that you have supplied to us
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Any amendment or rectification of your Registration Data in the User
          account can be carried out by accessing the "User account" section on
          the Website. You may choose to delete any or all of your User content/
          information or even the User account at any time. Processing such
          deletion may take some time, but the same shall be done by Igloo
          Digital Technologies Pvt Ltd. We may maintain backup of all User
          content for such time as may be required under applicable laws and for
          operational purposes of Igloo Digital Technologies Pvt Ltd. You are
          solely responsible for maintaining the confidentiality of your account
          and password and for any activity that occurs in or through your
          account. We will not be liable to any person for any loss or damage
          which may arise as a result of any failure on your part to protect
          your login ID or password or any other credential pertaining to your
          account. You should take all necessary steps to ensure that the
          password is kept confidential and secure. In the event of any dispute
          between two or more parties as to ownership of any particular account
          with Igloo Digital Technologies Pvt Ltd, you agree that Igloo Digital
          Technologies Pvt Ltd shall be the sole arbitrator for such dispute and
          that Igloo Digital Technologies Pvt Ltd's decision in this regard will
          be final and binding on you. You understand and undertake that you
          shall be solely responsible for your Registration Data and User
          content and undertake to, neither by yourself nor by permitting any
          third party to host, display, upload, modify, publish, transmit,
          update or share any information that:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          In order to access certain Services, you may be required to open a
          User account with Igloo Digital Technologies Pvt Ltd by providing
          information about yourself (such as identification or contact details)
          as part of the registration/sign up process ("REGISTRATION DATA") for
          the Services, or as part of your continued use of the Services. You
          agree that any Registration Data you give to Igloo Digital
          Technologies Pvt Ltd will always be accurate, correct, complete and up
          to date. If you provide any information that is untrue, inaccurate,
          incomplete, or not current or if we have reasonable grounds to suspect
          that such information is in violation of applicable law or not in
          accordance with the Terms of Use (whether wholly or in part), we
          reserve the right to reject your registration and/ or indefinitely
          suspend or terminate your User account and refuse to provide you
          access to the Website. Further, you agree to indemnify and keep us
          indemnified from and against all claims resulting from the use of any
          detail/ information/ Registration Data that you post and/ or supply to
          us. We shall be entitled to remove any such detail/ information/
          Registration Data posted by you without any prior intimation to you.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          a. Belongs to another person and to which you do not have any right
          to;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          b. Is grossly harmful, harassing, blasphemous, defamatory, obscene,
          pornographic, pedophilic, seditious, libelous, invasive of another\'s
          privacy, hateful, or racially, ethnically objectionable, disparaging,
          relating or encouraging money laundering or gambling, or otherwise
          unlawful in any manner whatsoever;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          c. Harms minors in any way; Infringes any patent, trademark, copyright
          or other proprietary rights of any person or entity anywhere in the
          world;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          d. Violates any law for the time being in force;{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          e. Deceives or misleads the addressee about the origin of such
          messages or communicates any information which is grossly offensive or
          menacing in nature;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          f. Impersonates another person;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          g. Contains software viruses or any other computer code, files or
          programs designed to interrupt, destroy or limit the functionality of
          any computer resource;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          h. Threatens the unity, integrity, defense, security or sovereignty of
          India, friendly relations with foreign states, or public order or
          causes incitement to the commission of any cognizable offence or
          prevents investigation of any offence or is insulting to any other
          nation; or
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          i. Is illegal in any other way.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You agree and understand that Igloo Digital Technologies Pvt Ltd
          reserves the right to remove and/or edit such detail/ information. If
          you come across any information as mentioned above on the Website, you
          are requested to immediately contact our Grievance officer.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You agree to use the Services only for purposes that are permitted by
          (a) these Terms of Use and (b) any applicable law, regulation or
          generally accepted practices or guidelines in the relevant
          jurisdictions.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You agree to use the data owned by Igloo Digital Technologies Pvt Ltd
          (as available on the Website or through any other means like API(s)
          etc.) only for personal purposes and not for any commercial use unless
          agreed to by Igloo Digital Technologies Pvt Ltd in writing.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You agree not to access (or attempt to access) any of the Services by
          any means other than through the interface that is provided by Igloo
          Digital Technologies Pvt Ltd, unless you have been specifically
          allowed to do so in a separate agreement with Igloo Digital
          Technologies Pvt Ltd. You specifically agree not to access (or attempt
          to access) any of the Services through any automated means (including
          use of scripts or web crawlers) and shall ensure that you comply with
          the instructions set out in any robots.txt file present on the
          Services.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You agree that you will not engage in any activity that interferes
          with or disrupts the Services (or the servers and networks which are
          connected to the Services) on this Website. Unless you have been
          specifically permitted to do so in a separate agreement with Igloo
          Digital Technologies Pvt Ltd, you agree that you will not reproduce,
          duplicate, copy, sell, trade or resell the Services for any purpose.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You agree that you are solely responsible for (and that Igloo Digital
          Technologies Pvt Ltd has no responsibility to you or to any third
          party for) any breach of your obligations under the Terms of Use and
          for the consequences (including any loss or damage which Igloo Digital
          Technologies Pvt Ltd may suffer) of any such breach. You further agree
          to the use of your data by us in accordance with the Privacy Policy.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Igloo Digital Technologies Pvt Ltd may share any Content (defined
          hereinafter) generated by the User or their Registration Data with
          governmental and regulatory agencies who are lawfully authorised for
          investigative, protective and cyber security activities. Such
          information may be transferred for the purposes of verification of
          identity, or for prevention, detection, investigation, prosecution
          pertaining to cyber security incidents and punishment of offences
          under any law for the time being in force.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          If you have opted for use of Igloo Digital Technologies Pvt Ltd's
          'subscriptions' product by virtue of which you have set up a standing
          instruction ("RECURRING PAYMENT INSTRUCTION") to charge your chosen
          payment method (such as credit card, debit card or bank account) as
          per the billing cycle communicated by you to Igloo Digital
          Technologies Pvt Ltd, then you consent that the relevant amount will
          be charged to such payment method as per the billing cycle
          communicated to Igloo Digital Technologies Pvt Ltd. You agree that
          Igloo Digital Technologies Pvt Ltd shall continue to charge the
          relevant amount to the relevant customer's chosen payment method as
          per such billing cycle until you or the customer terminates the
          Recurring Payment Instruction.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You further agree that if you revoke your consent to the Recurring
          Payment Instruction then you shall inform us of the revocation in
          writing for us to cease processing the Recurring Payment Instruction
          forthwith upon the revocation but no later than 7 (seven) days prior
          to the next instance of charge. If such intimation of revocation of
          Recurring Payment Instruction is made less than 7 (seven) days prior
          to the next instance of charge or is not made at all, Igloo Digital
          Technologies Pvt Ltd shall not be liable for any charge applied for
          that month pursuant to the revocation or not be liable at all, as
          applicable.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          4. Eligibility
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Any person who is above eighteen (18) years of age and competent to
          contract under the applicable laws is eligible to access or visit the
          Website or avail the Services displayed therein. Your use or access of
          the Website shall be treated as your representation that you are
          competent to contract and if you are registering as a business entity,
          then you represent and warrant that you have the authority to bind
          such business entity to the Terms of Use. Without generality of the
          foregoing, use of the Website is available only to persons who can
          form a legally binding contract under the Indian Contract Act, 1872
          and any amendments thereto.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          We record information relating to your use of Team Player, such as the
          The User represents and warrants that it will be financially
          responsible for all of User's usage (including the purchase of any
          Service) and access of the Website. The User shall also be responsible
          for use of User's account by others. The Terms of Use shall be void
          where prohibited by applicable laws, and the right to access the
          Website shall automatically stand revoked in such cases.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          5. Content in the Services
        </Typography>
        <Typography className={`${classes.form_lable}`}>
          For the purposes of these Terms of Use, the term "CONTENT" includes,
          without limitation, information, data, text, logos, photographs,
          videos, audio clips, animations, written posts, articles, comments,
          software, scripts, graphics, themes and interactive features
          generated, provided or otherwise made accessible on or through the
          Services.
        </Typography>
        <Typography className={`${classes.form_lable}`}>
          You should be aware that Content presented to you as part of the
          Services, including but not limited to advertisements in the Services
          and sponsored Content within the Services may be protected by
          intellectual property rights which are owned by the sponsors or
          advertisers who provide that Content to Igloo Digital Technologies Pvt
          Ltd (or by other persons or companies on their behalf). You may not
          modify, rent, lease, loan, sell, distribute or create derivative works
          based on this Content (either in whole or in part) unless you have
          been specifically told that you may do so by Igloo Digital
          Technologies Pvt Ltd or by the owners of that Content, in writing and
          in a separate agreement.
        </Typography>
        <Typography className={`${classes.form_lable}`}>
          Igloo Digital Technologies Pvt Ltd reserves the right (but shall have
          no obligation) to pre-screen, review, flag, filter, modify, refuse or
          remove any or all Content from any Service. Igloo Digital Technologies
          Pvt Ltd reserves the right to moderate, publish, re-publish, and use
          all User generated contributions and comments (including but not
          limited to reviews, profile pictures, comments, likes, favorites,
          votes) posted on the Website as it deems appropriate (whether in whole
          or in part) for its product(s), whether owned or affiliated. Igloo
          Digital Technologies Pvt Ltd is not liable to pay royalty to any User
          for re-publishing any content across any of its platforms.{" "}
        </Typography>
        <Typography className={`${classes.form_lable}`}>
          If you submit any material on the Website, you agree thereby to grant
          Igloo Digital Technologies Pvt Ltd the right to use, moderate, publish
          any such work worldwide for any of its product(s), whether owned or
          affiliated.
        </Typography>
        <Typography className={`${classes.form_lable}`}>
          You understand that by using the Services you may be exposed to
          Content that you may find offensive, indecent or objectionable and
          that, in this respect, your use of the Services will be at your own
          risk.
        </Typography>
        <Typography className={`${classes.form_lable}`}>
          You agree that you are solely responsible for (and that Igloo Digital
          Technologies Pvt Ltd has no responsibility to you or to any third
          party for) any Content that you create, transmit or display while
          using the Services and for the consequences of your actions (including
          any loss or damage which Igloo Digital Technologies Pvt Ltd may
          suffer) by doing so.{" "}
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          6. Proprietary Rights
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You acknowledge and agree that Igloo Digital Technologies Pvt Ltd (or
          Igloo Digital Technologies Pvt Ltd's licensors) owns all legal and
          proprietary right, title and interest in and to the Services,
          including any intellectual property rights which subsist in the
          Services (whether those rights happen to be registered or not, and
          wherever in the world those rights may exist). You further acknowledge
          that the Services may contain information which is designated
          confidential by Igloo Digital Technologies Pvt Ltd and that you shall
          not disclose such information without Igloo Digital Technologies Pvt
          Ltd's prior written consent.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Unless you have agreed otherwise in writing with Igloo Digital
          Technologies Pvt Ltd, nothing in the Terms of Use gives you a right to
          use any of Igloo Digital Technologies Pvt Ltd's trade names,
          trademarks, service marks, logos, domain names, and other distinctive
          brand features.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Unless you have been expressly authorized to do so in writing by Igloo
          Digital Technologies Pvt Ltd, you agree that in using the Services,
          you will not use any trade mark, service mark, trade name, logo of any
          company or organization in a way that is likely or intended to cause
          confusion about the owner or authorized User of such marks, names or
          logos.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          7. Exclusion of Warranties
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Nothing in these Terms of Use, including this paragraph 8, shall
          exclude or limit your warranty or liability for losses unless they are
          excluded or limited by applicable law. Some jurisdictions do not allow
          the exclusion of certain warranties or conditions or the limitation or
          exclusion of liability for loss or damage caused by negligence, breach
          of contract or breach of implied terms, or incidental or consequential
          damages. Accordingly, only the limitations which are lawful in your
          jurisdiction will apply to you and our liability will be limited to
          the maximum extent permitted by law. Igloo Digital Technologies Pvt
          Ltd disclaims any implied warranty for Services and any use thereof
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          You expressly understand and agree that your use of the Services is at
          your sole risk and that the Services are provided on an "as is" and
          "as available" basis. In particular, Igloo Digital Technologies Pvt
          Ltd, its subsidiaries and affiliates, and its licensors do not
          represent or warrant to you that:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. The information or Contents provided on the Website are accurate,
          complete and updated;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. Your use of the Services will meet your requirements;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          3. Your use of the Services will be uninterrupted, timely, secure or
          free from error;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          4. Any information obtained by you as a result of your use of the
          Services will be accurate or reliable; and
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          5. That defects in the operation or functionality of any software
          provided to you as part of the Services will be corrected.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Any material downloaded or otherwise obtained through the use of the
          Services is done at your own discretion and risk and that you will be
          solely responsible for any damage to your computer system or other
          device or loss of data that results from the download of any such
          material.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          No advice or information, whether oral or written, obtained by you
          from Igloo Digital Technologies Pvt Ltd or from the use of Services
          shall create any warranty not expressly stated in these Terms of Use.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Igloo Digital Technologies Pvt Ltd further expressly disclaims all
          warranties and conditions of any kind, whether express or implied,
          including, but not limited to the implied warranties and conditions of
          merchantability, fitness for a particular purpose and
          non-infringement.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          8. Representations and Warranties of User
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The User hereby represents and warrants:
        </Typography>{" "}
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. That User, in case of a natural person, is at least 18 years old
          with a conscious mind fit and proper to enter into this agreement (the
          "Policies"), is with valid credentials and is an entity who is legally
          eligible to carry out or operate a business;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. That User/ seller shall be solely responsible for understanding and
          complying with any and all applicable laws relevant to the User and
          their business, and any liability, whether pecuniary or otherwise,
          arising from any non-compliance of such applicable laws shall be at
          the sole cost and risk of such User;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          3. That all data, information, inventions, intellectual properties
          (including patents, trademarks, copyrights, design and trade secrets),
          know-how, new uses and processes, and any other intellectual property
          right, asset or form, including, but not limited to, analytical
          methods, procedures and techniques, research, procedure manuals,
          financial information, computer technical expertise, software for the
          purpose of availing of services of Igloo Digital Technologies Pvt Ltd
          and any updates or amendments thereto is and shall be the sole
          intellectual property of Igloo Digital Technologies Pvt Ltd and should
          in no way be construed to grant any rights and/ or title to the User
          in such intellectual property of Igloo Digital Technologies Pvt Ltd;
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          9. Indemnity
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The User shall indemnify and hold Igloo Digital Technologies Pvt Ltd,
          its subsidiaries, affiliates, promoters, directors, employees,
          contractors, licensors and agents and any other related or third
          parties involved with Igloo Digital Technologies Pvt Ltd in any manner
          whatsoever, harmless from and against all losses arising from claims,
          demands, actions or other proceedings as a result of:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. Fraud, negligence and willful misconduct by the User in the use of
          the Services;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. Violation of applicable laws in the use of the Services and/ or in
          the conduct of the business of the User, including but not limited to
          the legal provisions{" "}
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          10. Limitation of Liability
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Subject to the overall provisions stated above, you expressly
          understand and agree that Igloo Digital Technologies Pvt Ltd, its
          subsidiaries, affiliates, promoters, directors, employees, agents and
          licensors shall not be liable to you for:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. Any direct, indirect, incidental, special, consequential, punitive
          or exemplary damages which may be incurred by you, however caused and
          under any theory of liability. This shall include, but not be limited
          to, any loss of profit (whether incurred directly or indirectly), any
          loss of goodwill or business reputation, any loss of data suffered,
          cost of procurement of substitute goods or Services, or other
          intangible loss;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. The deletion of, corruption of, or failure to store, any content
          and other communications data maintained or transmitted by or through
          your use of the Services;
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          3. Your failure to keep your password or account details secure and
          confidential.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The limitations on Igloo Digital Technologies Pvt Ltd's liability to
          you shall apply whether or not Igloo Digital Technologies Pvt Ltd has/
          had been advised of or should have been aware of the possibility of
          any losses to you{" "}
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          11. Force Majeure
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Igloo Digital Technologies Pvt Ltd shall not be in breach of its
          obligation hereunder if it is delayed in the performance of, or is
          unable to perform (whether partially or fully) its obligations
          (provide the Services) as a result of the occurrence of a Force
          Majeure Event (defined below).
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Force Majeure Event means any event, whatever be the origin, not
          within the reasonable control of Igloo Digital Technologies Pvt Ltd,
          which Igloo Digital Technologies Pvt Ltd is unable to prevent, avoid
          or remove or circumvent by the use of reasonable diligence. Force
          Majeure event shall include, but shall not be limited to, acts of god,
          acts, orders, directions of governmental/ regulatory/ judicial/
          quasi-judicial/ law enforcement authorities/ agencies which hinders
          Igloo Digital Technologies Pvt Ltd from performing its obligations
          under any agreement, including these Terms of Use, with you, war,
          hostilities, invasion, armed conflict, act of foreign enemy,
          embargoes, riot, insurrection, labour stoppages, outages and downtimes
          systems failures experienced by a facility provider, revolution or
          usurped power, acts of terrorism, sabotage, nuclear explosion,
          earthquake, pandemic, epidemic, hacking or man in the middle attack or
          similar attacks/ intrusions, fires, typhoons, storms and other natural
          catastrophes.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Any payment obligations of Igloo Digital Technologies Pvt Ltd, in case
          of a Force Majeure event, shall be limited by and be subject to the
          fulfillment of the payment obligations of the partners banks/
          financial institutions, counterparties and any other parties involved
          in or intrinsically linked to the provision of the Services of Igloo
          Digital Technologies Pvt Ltd.{" "}
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12. Confidentiality
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The User may receive or have access to certain confidential and
          proprietary information, including without limitation, information
          belonging and/or relating to Igloo Digital Technologies Pvt Ltd and
          its affiliates, marketing prospects, contractors, officers, directors
          or shareholders, personal data of customers of the User, financial and
          operational information, billing records, business model and reports,
          computer systems and modules, secure websites, reporting systems,
          marketing strategies, operational plans, proprietary systems and
          procedures, trade secrets and other similar proprietary information,
          including technical "know-how", methods of operation, business
          methodologies, software, software and technology architecture,
          networks, any other information not generally available to the public,
          and any items in any form in writing or oral, clearly identified as
          confidential ("CONFIDENTIAL INFORMATION").
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The User shall keep Confidential Information in confidence. The User
          shall use commercial, reasonable and necessary safety measures and
          steps to maintain the confidentiality and secrecy of the Confidential
          Information from public disclosure, and the User shall at all times
          maintain appropriate measures to protect the security and integrity of
          the Confidential Information. The User shall not, without Igloo
          Digital Technologies Pvt Ltd's prior written consent, divulge any of
          the Confidential Information to any third party other than the User's
          officers, employees, agents or representatives who have a need to know
          for the purposes of these Terms of Use. The User shall take all
          reasonable steps to ensure that all of its directors, managers,
          officers, employees, agents, independent contractors or other
          representatives comply with this paragraph 12 whenever they are in
          possession of Confidential Information as part of this Agreement. The
          User shall use the Confidential Information solely in furtherance of
          and in connection with the Services contemplated under these Terms of
          Use. The User further agrees that the Confidential Information will
          not be used by him/ her and his/ her representatives, in any way
          detrimental to the interests of Igloo Digital Technologies Pvt Ltd.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12. Payments
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          In consideration of the Services rendered by us, you shall pay Igloo
          Digital Technologies Pvt Ltd a subscription fee or product fee
          ("FEE"). Igloo Digital Technologies Pvt Ltd reserves the right to
          revise the Fee periodically and will intimate you of any such change
          within reasonable time.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Igloo Digital Technologies Pvt Ltd shall be entitled to charge on the
          Fee, taxes applicable from time to time ("APPLICABLE TAXES"). It is
          agreed that any statutory variations in Applicable Taxes during the
          subsistence of this Agreement shall be borne by the User. Periodic
          invoices shall be raised by us in respect of the Fees charged. In case
          the payment for the invoice is not received within seven (7) calendar
          days, Igloo Digital Technologies Pvt Ltd reserves the right to
          discontinue Services without prior notice. The Services may be
          reactivated after a penalty charge.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Any reasonable dispute in respect of an amount (or a portion thereof)
          mentioned in an invoice must be communicated by the User via notice
          ("INVOICE DISPUTE NOTICE") within a reasonable period of time but no
          later than seven (7) calendar days from the date of the invoice. Igloo
          Digital Technologies Pvt Ltd shall use good faith efforts to reconcile
          any reasonably disputed amounts within reasonable time from the
          receipt of the Invoice Dispute Notice.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Further, Igloo Digital Technologies Pvt Ltd also reserves the right to
          close, suspend, limit or put on hold the User's access to the account
          with Igloo Digital Technologies Pvt Ltd inter alia the following
          scenarios:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • For violation of any of the provisions of these "Terms of Use";
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • For violation of any of the provisions of any other agreement that
          the User has entered into or might enter into with Igloo Digital
          Technologies Pvt Ltd; and
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • For violation of any of the applicable laws by such User.{" "}
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12. Technical Issues & Delivery Policy
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          In case of any technical issues, please raise a support ticket from
          your service dashboard or:{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. Email us at support@teamplayer.in (Monitored 10:00a.m. to 6:00p.m.;
          Monday – Friday). Emails received outside of office hours will be
          collected, however no action can be guaranteed until the next working
          day
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. Call Us on +918657599000 in case of urgent matters. Telephone
          support: 10:00 a.m. to 6:00p.m., Monday – Friday. Calls received out
          of office hours will be forwarded to a mobile phone and best efforts
          will be made to answer / action the call.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Igloo Digital Technologies Pvt Ltd will respond to service-related
          incidents and/or requests submitted by the User within the following
          time frames:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. 0-3 hours (during business hours) for issues classified as Major
          issues.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. Within 3 working days for issues classified as Medium issues.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          3. Within 7 working days for issues classified as Minor issues.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Remote assistance will be provided in-line with the above timelines
          depending on the priority of the support request.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Definitions-
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. Major issues - Any issues with admin panel (such as website down or
          crashes whenever you attempt to perform an action on
          www.teamplayer.in)
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. Medium issue- Any issues with the Team player app (such as app
          crash for individual user, location data not flowing properly to admin
          panel)
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          3. Minor issue- any other issues
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12. Termination of Services
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Termination for Material Breach. Each Party may terminate this
          Agreement with immediate effect by delivering notice of the
          termination to the other Party, if the other Party (i) fails to
          perform the obligation under this Agreement; (ii) has made or makes
          any inaccuracy in performance of this Agreement; or (iii) otherwise
          materially breaches, any of its obligations, covenants, or
          representations made in this Agreement, and the failure, inaccuracy,
          or breach continues for a period of 15 (fifteen) Business Days' after
          the injured Party delivers notice to the breaching Party reasonably
          detailing the breach.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Termination for Failure to Pay. Igloo Digital Technologies Pvt Ltd
          may terminate this Agreement with immediate effect by delivering
          notice of the termination to User, if User fails to pay the monthly
          Subscription Fee on time for more than 2 (two) consecutive months.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Termination by will. Either Party may terminate this Agreement by
          giving 1(one) month notice of such termination to the other Party of
          its intention to terminate.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Effect of Termination
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          1. Refund Amounts. Igloo Digital Technologies Pvt Ltd shall refund to
          User in next 30 (thirty) days, any prepaid Subscription Fees covering
          the remainder of the term of all subscriptions after the effective
          date of termination (only if terminated because of Severity 1 as given
          in definitions). No amount shall be refunded in case of any other
          breach.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          2. Pay Outstanding Amounts. User shall immediately pay to Igloo
          Digital Technologies Pvt Ltd all amounts outstanding as of the date
          and any amounts outstanding as a result of, termination. If the
          termination is due to breach by Igloo Digital Technologies Pvt Ltd
          then the client is not liable to pay the outstanding dues.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          3. Discontinuance of Use. User shall cease all use of the Service upon
          the effective date of the termination.{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          4. Recovery of Data. User will have 7 (Seven) Business Days from the
          effective date of termination to retrieve any of data that User wishes
          to keep
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12. System Availability
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Applicable Levels. Igloo Digital Technologies Pvt Ltd shall provide
          the Service to the User with a System Availability of at least 95%
          (Ninety- Five per cent) during each calendar month.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          System Maintenance. Igloo Digital Technologies Pvt Ltd may take the
          Service offline for scheduled maintenances provided it informs the
          User the schedule for maintenance in writing via email. This scheduled
          maintenance time is outside the scope of System Availability and will
          not be considered in estimating System Availability. Scheduled
          maintenance will not exceed once a month. For unscheduled maintenance
          the system should be up and running in no less than 3 hours or else
          there is a penalty clause.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12. System Availability Definition
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Percentage of Minutes per Month. "System Availability" means the
          percentage of minutes in a month that the key components of the
          Service are operational.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Not Included in "System Availability. "System Availability" will not
          include any minutes of downtime resulting from scheduled maintenance,
          events of force majeure, malicious attacks on the system, issues
          associated with User's computing devices, or Igloo Digital
          Technologies Pvt Ltd’s inability to deliver services because of User's
          acts or omissions.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12. System Availability Definition
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          The data (pertaining to your account) in the following categories will
          be available as per timelines mentioned below. Post expiry of the
          stated timeline the data will be deleted. Thereafter, Igloo Digital
          Technologies Pvt Ltd will not be able to provide this data to you. In
          case you would like to retain records, please download this data
          before such date.
        </Typography>
        <TableContainer sx={{ maxWidth: 800, mt: 3 }}>
          <Typography variant="h6" sx={{ p: 2 }}>
            Data Retention Policy
          </Typography>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1976d2" }}>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  Type of Data
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  Retention Period (in days)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  Data on Team member’s Location, Conveyance & Travel
                </TableCell>
                <TableCell>90</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Data on Meetings & Tasks, Leaves, Attendance, 365 Dashboards
                  (except location, travel & conveyance)
                </TableCell>
                <TableCell>365</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Static Data (Admin Hierarchy, Team members’ Information,
                  Teams, Designations, Forms, Shifts & Rosters, Sites, Site
                  Pools)
                </TableCell>
                <TableCell>Unlimited*</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Typography
            variant="body2"
            sx={{ p: 2, textAlign: "center", fontStyle: "italic" }}
          >
            *These timelines are subject to change at the discretion of Igloo
            Digital Technologies Pvt Ltd. Any change will be informed to you via
            email.*
          </Typography>
        </TableContainer>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          12.Governing Law, Settlement of Disputes and Jurisdiction
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          These Terms of Use and any dispute or claim arising under it will be
          governed by and construed in accordance with the laws of India. The
          Users agree that any legal action or proceedings arising out of these
          Terms of Use or in connection with these Terms of Use may be brought
          EXCLUSIVELY in the competent courts/ tribunals having jurisdiction in
          Mumbai, India and the Users irrevocably submit themselves to the
          jurisdiction of such courts/ tribunals.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          {" "}
          15.Privacy{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          YOUR PRIVACY IS EXTREMELY IMPORTANT TO US. UPON ACCEPTANCE OF THESE
          TERMS OF USE YOU CONFIRM THAT YOU HAVE READ, UNDERSTOOD AND
          UNEQUIVOCALLY ACCEPTED OUR POLICIES, INCLUDING THE PROVISIONS OF OUR
          PRIVACY POLICY.
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          {" "}
          15.Complaints and Regulatory and Customer Grievance Redressal**{" "}
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          ANY COMPLAINTS OR CONCERNS WITH REGARDS TO CONTENT OF THIS WEBSITE OR
          COMMENT OR BREACH OF THESE TERMS OF USE OR ANY INTELLECTUAL PROPERTY
          OF ANY USER, INSTANCES OF CUSTOMER GRIEVANCES, REGULATORY QUERIES AND
          CLARIFICATIONS SHALL BE INFORMED/ COMMUNICATED TO THE GRIEVANCE
          OFFICER AT THE CO- ORDINATES MENTIONED BELOW IN WRITING OR BY WAY OF
          RAISING A GRIEVANCE TICKET THROUGH THE HYPERLINK MENTIONED BELOW:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          GRIEVANCE CUM NODAL OFFICER IGLOO DIGITAL TECHNOLOGIES PVT LTD
          ADDRESS: PH: +918657599000
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          E-MAIL: support@teamplayer.in
        </Typography>
        <Typography className={classes.mainText} sx={{ mb: 2 }}>
          {" "}
          15.SCHEDULE I –
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          Team player offers Team Management Platform that performs the
          following services:
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Location Tracking • Leave Management • Chat Module • Web Module •
          Analytical Reports
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Attendance Management
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Location Assigning
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Leave Management
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Chat Module • Web Module • Analytical Reports
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          • Analytical Reports
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          All the products/services offered on our domain www.teamplayer.in and
          related apps (Android & iOS) including add-ons such as customer
          support, training, data storage etc. These are subject to change from
          time to time and without notice.
        </Typography>
        <Typography className={classes.form_lable} sx={{ mb: 3 }}>
          I HEREBY CONFIRM THAT I HAVE READ THESE TERMS OF USE AND ACCEPT THEM.
        </Typography>
      </Paper>
    </div>
  );
};

export default TermConditions;
